var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1172 1367",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7415.08,-2211.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    transform: "matrix(0.472206,0,0,0.389561,7415.08,2211.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.3029,0,0,22.1859,585.057,24.8424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,51C102,22.852 79.148,0 51,0C22.852,0 0,22.852 0,51L0,106C0,134.148 22.852,157 51,157C79.148,157 102,134.148 102,106L102,51Z",
    style: {
      fill: "rgb(241,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18329,0,0,1.18301,-253.345,-304.705)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-79.5909,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-679.063,-1162.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 873.153,2031.55 873.153,2031.55L1350.74,2031.55C1350.74,2031.55 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1383.82,1520.71 1383.82,1520.71C1383.82,1520.71 1429.83,1543.7 1465.67,1561.62C1491.54,1574.55 1522.24,1573.2 1546.88,1558.07C1573.48,1541.72 1603.7,1523.15 1603.7,1523.15C1603.7,1523.15 1607.49,1518.43 1612.18,1512.58C1623.75,1498.14 1630.31,1480.34 1630.88,1461.84C1630.92,1460.54 1630.96,1459.23 1631,1457.93C1631.62,1437.69 1626.67,1417.67 1616.71,1400.05C1591.04,1354.68 1537.91,1260.77 1496.38,1187.35C1460.74,1124.34 1394.41,1084.91 1322.03,1083.69C1263.99,1082.71 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 872.173,1148.03 784.788,1188.87C738.468,1210.52 701.953,1248.76 682.456,1296.02C649.816,1375.15 602.51,1489.84 602.51,1489.84L817.958,1580.35L836.241,1544.5C836.241,1544.5 888.09,1706.17 888.555,1762.93C889.02,1819.69 873.153,2031.55 873.153,2031.55L1350.74,2031.55C1350.74,2031.55 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1383.82,1520.71 1383.82,1520.71C1383.82,1520.71 1429.83,1543.7 1465.67,1561.62C1491.54,1574.55 1522.24,1573.2 1546.88,1558.07C1573.48,1541.72 1603.7,1523.15 1603.7,1523.15C1603.7,1523.15 1607.49,1518.43 1612.18,1512.58C1623.75,1498.14 1630.31,1480.34 1630.88,1461.84C1630.92,1460.54 1630.96,1459.23 1631,1457.93C1631.62,1437.69 1626.67,1417.67 1616.71,1400.05C1591.04,1354.68 1537.91,1260.77 1496.38,1187.35C1460.74,1124.34 1394.41,1084.91 1322.03,1083.69C1263.99,1082.71 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192.21,1145.23L1383.04,1234.34L1620.64,1569.57L1716.7,1530.41L1677.53,1419.58L1481.25,1082.94L1142.91,1029.15L1192.21,1145.23Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.695,1608.08L551.729,1481.39C551.729,1481.39 655.914,1488.55 725.548,1493.34C764.8,1496.04 803.564,1483.37 833.647,1458.01C848.137,1445.79 860.368,1435.48 860.368,1435.48C860.368,1435.48 873.441,1453.95 888.636,1475.41C917.731,1516.51 964.54,1541.44 1014.88,1542.65C1114.46,1545.03 1271.6,1548.79 1271.6,1548.79L1357.32,1426.75C1357.32,1426.75 1377.67,1442.86 1398.23,1459.13C1425.51,1480.72 1459.38,1492.27 1494.16,1491.84C1560.42,1491.03 1664.32,1489.76 1664.32,1489.76L1389.3,1793.81C1389.3,1793.81 1342.08,1779 1286.49,1761.57C1175.15,1726.65 1053.94,1744.94 957.879,1811.16C873.906,1869.05 786.474,1929.32 786.474,1929.32L830.695,1608.08Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51.4616,-5.85918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,48.5761,166.926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1194.71,911.832L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1194.71,911.832L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081.89,1037.51C1081.89,1037.51 1099.57,1038.19 1117.86,1038.89C1140.15,1039.75 1157.77,1058.06 1157.77,1080.36L1157.77,1271.53L1384.15,1066.07L1192.43,931.554L1150.1,964.475L1081.89,1037.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1010.22,1105.14 1024.57,1074.59C1034.34,1053.8 1055.26,1040.53 1078.23,1040.56C1089.09,1040.58 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78314,0.185352,-0.152875,2.16196,-612.722,-1539.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3230.97,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.983331,-0.181822,0.181822,0.983331,-160.232,90.7034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.937008,-0.349307,-0.349307,0.937008,2482.46,424.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.986502,-0.163752,0.163752,0.986502,-125.026,179.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-2.77556e-17,2.77556e-17,-1,2249.6,1763.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.25915,3.49485e-17,3.49485e-17,1.25915,2578.44,-121.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,2.77556e-17,2.77556e-17,-1,-1.50787,1763.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.91,875.309 1161.36,879.583L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3214.71,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.77611,-0.26673,-0.219994,2.15343,5342.39,-976.541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1599.97,1560.23C1566.46,1595.38 1564.32,1649.96 1594.97,1687.62C1594.97,1687.62 1594.97,1687.62 1594.97,1687.62C1614.84,1712.02 1645.6,1724.87 1676.93,1721.85C1708.25,1718.82 1735.99,1700.33 1750.82,1672.57C1824.75,1534.19 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1889.58,1256.46C1889.58,1256.46 1699.2,1456.15 1599.97,1560.23Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1599.97,1560.23C1566.46,1595.38 1564.32,1649.96 1594.97,1687.62C1594.97,1687.62 1594.97,1687.62 1594.97,1687.62C1614.84,1712.02 1645.6,1724.87 1676.93,1721.85C1708.25,1718.82 1735.99,1700.33 1750.82,1672.57C1824.75,1534.19 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1889.58,1256.46C1889.58,1256.46 1699.2,1456.15 1599.97,1560.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2267,1011.12C2267,1011.12 2267,1011.12 2267,1011.12C2303.57,1025.31 2345.11,1014.69 2370.37,984.683C2395.63,954.682 2399.02,911.941 2378.81,878.327C2280.89,715.438 2166.81,525.683 2166.81,525.683L2003.37,575.284L2267,1011.12Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,68.3227,106.761)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.50539,1.17349,-0.967871,1.8252,-384.1,-2431.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1436.49,1607.49 1456.88,1692.76C1472.61,1758.55 1538.47,1799.34 1604.38,1784.11C1604.38,1784.11 1604.38,1784.11 1604.38,1784.11C1620.66,1780.35 1635.39,1771.63 1646.52,1759.15C1693.94,1705.4 1830.88,1544.73 1949.2,1352.36L1894.75,1288.23L1889.78,1286.93L1614.96,1545.11L1605.06,1473.86L1412.6,1507.59Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1412.6,1507.59C1412.6,1507.59 1436.49,1607.49 1456.88,1692.76C1472.61,1758.55 1538.47,1799.34 1604.38,1784.11C1604.38,1784.11 1604.38,1784.11 1604.38,1784.11C1620.66,1780.35 1635.39,1771.63 1646.52,1759.15C1693.94,1705.4 1830.88,1544.73 1949.2,1352.36L1894.75,1288.23L1889.78,1286.93L1614.96,1545.11L1605.06,1473.86L1412.6,1507.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1861.47,-627.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.189424,0.983148,266.866,-257.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.4,1199.1 2069.96,1216.61C2070.18,1223.37 2069.14,1230.05 2066.9,1236.31C2060.95,1252.96 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,181.083,-252.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.28,1195.58 2069.87,1213.67C2070.15,1222.32 2068.37,1230.92 2064.68,1238.76C2057.98,1252.97 2047.69,1274.81 2047.69,1274.81L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,162.151,-212.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2068.82,1181.09 2069.32,1196.69C2069.55,1203.89 2066.43,1210.79 2060.86,1215.37C2055.3,1219.94 2047.93,1221.67 2040.91,1220.06C2040.91,1220.06 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.189424,0.983148,266.866,-257.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.39,1147.52 2025.87,1133.96C2023.08,1128.16 2025.3,1121.42 2030.88,1118.74C2030.88,1118.74 2030.88,1118.74 2030.88,1118.74C2036.44,1116.06 2043.33,1118.46 2046.35,1124.12C2054.34,1139.1 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,181.083,-252.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.18,1147.1 2025.68,1133.58C2023.02,1128.04 2025.35,1121.4 2030.88,1118.73C2030.88,1118.73 2030.88,1118.73 2030.88,1118.73C2036.49,1116.04 2043.22,1118.24 2046.14,1123.72C2054.1,1138.63 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,162.151,-212.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.18,1147.1 2025.68,1133.58C2023.02,1128.04 2025.35,1121.4 2030.88,1118.73C2030.88,1118.73 2030.88,1118.73 2030.88,1118.73C2036.49,1116.04 2043.22,1118.24 2046.14,1123.72C2054.1,1138.63 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1889.78,1286.93L1996.03,1260.83L2040.91,1220.06L2070.3,1226.62C2070.3,1226.62 2064.26,1255.63 2059.92,1276.49C2057.18,1289.68 2048.66,1300.95 2036.72,1307.2C2005.03,1323.76 1944.59,1355.37 1944.59,1355.37L1889.78,1286.93Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.712393,0.70178,-0.70178,0.712393,1443.44,-1081.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.87685,0,0,2.27558,-10923,-3755.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6579.59,
    cy: 2429.92,
    r: 196.812,
    style: {
      fill: "rgb(196,201,216)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.87685,0,0,2.27558,-10934.3,-3782.99)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6579.59,
    cy: 2429.92,
    r: 196.812,
    style: {
      fill: "rgb(226,228,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.393195,2.11687,-1.74596,0.476726,2835.86,-2711.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.19,1147.11 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648884,2.02224,-1.66791,0.786735,2157.22,-2720.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.61,1301.89C1894.61,1301.89 1892.53,1290.31 1890.66,1279.9C1888.74,1269.19 1888.8,1258.22 1890.84,1247.53C1894.15,1230.13 1898.95,1204.91 1898.95,1204.91L1935.62,1223.9L1941.13,1277.36L1894.61,1301.89Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990187,-1.80751,-1.4908,-1.20054,1287.88,7035.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1930.84,1186.59 1946.83,1177.48C1952,1174.53 1958.51,1175.45 1962.66,1179.72C1962.66,1179.72 1962.66,1179.72 1962.66,1179.72C1965.1,1182.22 1966.43,1185.59 1966.37,1189.08C1966.3,1192.57 1964.84,1195.89 1962.32,1198.3C1951.51,1208.61 1935.39,1224 1935.39,1224L1898.62,1204.95Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.448186,2.10074,1.73265,-0.5434,-1504.8,-2250.66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,103.011,-157.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.977656,0.210211,0.23343,-1.08564,-259.645,2101.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.6,1197.58 2042.1,1181.73C2042.22,1177.77 2043.83,1174.04 2046.54,1171.45C2049.25,1168.85 2052.82,1167.61 2056.39,1168.03C2056.65,1168.06 2056.91,1168.09 2057.17,1168.12C2063.56,1168.86 2068.49,1174.68 2068.74,1181.76C2069.32,1198.64 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3995.34,2625.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.601081,-0.799188,0.887462,-0.667472,2230.44,3642.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(234,148,90)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2039.84,1217.13C2039.84,1217.13 2040.08,1194.62 2040.26,1179C2040.3,1175.14 2041.89,1171.46 2044.68,1168.79C2047.47,1166.13 2051.21,1164.69 2055.07,1164.82C2055.07,1164.82 2055.07,1164.82 2055.07,1164.82C2062.52,1165.07 2068.49,1171.05 2068.73,1178.5C2069.1,1189.85 2069.62,1205.98 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2039.84,1217.13Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2045.49,514.403L2108.7,445.788C2108.7,445.788 2032.09,396.735 2002.92,378.063C1996.78,374.132 1994.96,365.987 1998.83,359.811C1998.83,359.81 1998.83,359.81 1998.83,359.809C2000.72,356.807 2003.72,354.682 2007.18,353.906C2010.64,353.129 2014.26,353.766 2017.25,355.675C2045.34,373.636 2117.32,419.648 2133.82,430.189C2139.24,433.652 2149.43,447.085 2159.66,461.887C2178.42,488.836 2177.44,524.86 2157.24,550.749C2156.94,551.144 2156.64,551.532 2156.34,551.918C2143.31,568.621 2120.92,574.894 2101.11,567.393C2099.3,566.706 2097.62,565.947 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2045.49,514.403 2045.49,514.403Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2045.49,514.403L2108.7,445.788C2108.7,445.788 2032.09,396.735 2002.92,378.063C1996.78,374.132 1994.96,365.987 1998.83,359.811C1998.83,359.81 1998.83,359.81 1998.83,359.809C2000.72,356.807 2003.72,354.682 2007.18,353.906C2010.64,353.129 2014.26,353.766 2017.25,355.675C2045.34,373.636 2117.32,419.648 2133.82,430.189C2139.24,433.652 2149.43,447.085 2159.66,461.887C2178.42,488.836 2177.44,524.86 2157.24,550.749C2156.94,551.144 2156.64,551.532 2156.34,551.918C2143.31,568.621 2120.92,574.894 2101.11,567.393C2099.3,566.706 2097.62,565.947 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2045.49,514.403 2045.49,514.403Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1993.59,366.014L2111.69,442.514L2108.6,445.733L2066.22,422.191L1993.51,383.447L1993.59,366.014Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.45886,-0.888508,-0.888508,0.45886,4015.15,2470.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.46,1198.26 2040.07,1180.46C2039.89,1172.41 2046.27,1165.74 2054.32,1165.57C2054.32,1165.57 2054.32,1165.57 2054.32,1165.57C2062.19,1165.39 2068.74,1171.56 2069.05,1179.42C2069.8,1198.72 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24093,0,0,1.24063,-339.137,-358.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-9402.81,-6354.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6021.85,3705.43L6147.31,3830.9",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "23.84px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2887e-15,-2.16989,1.78968,3.98736e-15,-5257.17,15024.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6021.85,3705.43L6147.31,3830.9",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "23.84px"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyFailed);
export default __webpack_public_path__ + "static/media/guy_failed.0fe5141fd742266edc333c2b23d1dfeb.svg";
export { ForwardRef as ReactComponent };